import reduce from 'reduce-reducers';

type ExtendedAction<A> = A | any;

type Reducer<S, A> = (state: S, action: ExtendedAction<A>) => S;
export const reduceReducers = <S, A>(initialState: S, ...reducers: Reducer<S, ExtendedAction<A>>[]) =>
	(reduce<S>(initialState, ...reducers) as unknown) as (state: S, action: A) => S;
